function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import SlideShowComponent from "./SlideShowComponent";
import { getURLFromField } from "../utils";
import useElements from "../hooks/useElements";
const SlideShow = ({
  value,
  ...props
}) => {
  const wuiltContext = useElements();
  const imageLoader = wuiltContext?.base?.imageLoader;
  const slides = value?.map(slide => ({
    id: slide?.id,
    src: imageLoader({
      src: getURLFromField(slide.image)
    })
  })) || [];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SlideShowComponent, _extends({}, props, {
    images: slides
  })));
};
export default SlideShow;
//# sourceMappingURL=SlideShow.js.map